export default __webpack_public_path__ + "static/media/GR00011-languages_card_1.20f2008c.svg";